import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["popup"];

  connect() {
    this.outsideClick = this.closePopup.bind(this);
  }

  togglePopup(event) {
    event.stopPropagation(); // Prevent immediate closure
    if (this.popupTarget.classList.contains("hidden")) {
      this.popupTarget.classList.remove("hidden");
      document.addEventListener("click", this.outsideClick);
    } else {
      this.closePopup();
    }
  }

  closePopup() {
    this.popupTarget.classList.add("hidden");
    document.removeEventListener("click", this.outsideClick);
  }

  share(event) {
    event.preventDefault();
    event.stopPropagation();

    const platform = event.currentTarget.dataset.platform;
    const url = window.location.href;
    let shareUrl = "";

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
        break;
      case "instagram":
        alert("Instagram does not support direct URL sharing.");
        return;
      case "copy":
        navigator.clipboard.writeText(url);
        alert("Link copied to clipboard!");
        return;
      default:
        return;
    }

    window.open(shareUrl, "_blank", "width=600,height=400");
    this.closePopup();
  }
}
